import request from '@/utils/request'
import { contactsList, apitypeList } from './contacts_score_config.js'

// 提交idfa 和通讯录
function addressBook () {
  const contant = getContactsFromStorage()
  const idfa = localStorage.getItem('idfa') || ''
  if (contant || idfa) {
    const contantList = JSON.stringify(contant) || JSON.stringify([])
    request.post('addressBook', { contantList, idfa: idfa.replace(/"/g, '') })
  }
}

// 判断是否使用最新的相机逻辑
export function isUseLatestLogic () {
  const LATEST_CAMERA_API_TYPES = apitypeList
  const type = sessionStorage.getItem('apitype')
  return LATEST_CAMERA_API_TYPES.includes(type)
}

// 兼容多种通讯录储存到localStorage的key
export function getContactsFromStorage () {
  let contant = ''
  // 使用some方法，当找到有值的key时会自动终止循环
  contactsList.some(key => {
    const valueJSON = localStorage.getItem(key.contactKey)
    if (valueJSON) {
      const valueArray = JSON.parse(valueJSON)
      contant = valueArray.map(item => ({
        accountName: item[key.name],
        accountPhone: item[key.phone]
      }))
      return true
    }
    return false
  })
  return contant
}
export default addressBook
